export enum LocaleTypes {
  'en' = 'en',
  'ru' = 'ru',
  'he' = 'he',
  'fr' = 'fr'
}
